module.exports = __webpack_public_path__ + "img/ic_deconnexion.12cb36aa.svg";